import React from "react";

export default function AdminHeader({ toggle }) {
  return (
    <div className="bg-white shadow-sm p-3 d-flex justify-content-between align-items-center">
      <button className="btn btn-outline-secondary" onClick={toggle}>
        ☰
      </button>

      <h5 className="m-0">Admin Dashboard</h5>

      <div>
        <span className="me-3">Admin</span>
      </div>
    </div>
  );
}